import React from 'react';
import { cn } from '../../lib/utils';

// Design-system note: badges use the onyx neutral ramp + Lodge Orange only.
// No slate/blue/purple. Onyx tokens auto-invert in dark mode via theme.css.
const Badge = React.forwardRef(({ className, variant = 'default', ...props }, ref) => {
  const variants = {
    default: 'bg-[var(--lodge-onyx-900)] text-white hover:opacity-90',
    secondary: 'bg-[var(--lodge-onyx-100)] text-[var(--lodge-onyx-900)] hover:opacity-90',
    outline: 'text-[var(--lodge-onyx-900)] border border-[var(--lodge-onyx-200)]',
    // "Beta"/informational tag — neutral onyx (was off-palette blue)
    beta: 'bg-[var(--lodge-onyx-100)] text-[var(--lodge-onyx-500)] border border-[var(--lodge-onyx-200)]',
    // Delegated/owned-by tag — neutral onyx (was off-palette purple)
    delegated: 'bg-[var(--lodge-onyx-100)] text-[var(--lodge-onyx-600)] border border-[var(--lodge-onyx-200)]',
    new: 'bg-[var(--lodge-orange-50)] text-[var(--lodge-orange-500)] border border-[var(--lodge-orange-200)]',
  };

  return (
    <div
      ref={ref}
      className={cn(
        'inline-flex items-center rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--lodge-orange-400)] focus:ring-offset-2',
        variants[variant],
        className
      )}
      {...props}
    />
  );
});

Badge.displayName = 'Badge';

export { Badge };
